import { Helmet } from 'react-helmet-async';

/**
 * ProducerBuddy — Global SEO Component
 * Tagline: "All in One Film Solution"
 *
 * Usage:
 * <SEO
 *   title="Script AI"
 *   description="Write your film script in minutes..."
 *   url="https://producerbuddy.pilomation.com/script"
 * />
 */

const SEO = ({ title, description, url, image, robots = 'index, follow' }) => {
  const BASE_URL = 'https://producerbuddy.pilomation.com';
  const DEFAULT_IMAGE = `${BASE_URL}/og-default.jpg`;
  const DEFAULT_DESC = "ProducerBuddy — the all in one film solution for filmmakers worldwide. Script. Budget. Cast. Track. Distribute — powered by AI.";
  const SITE_NAME = 'ProducerBuddy';

  const fullTitle = title
    ? `${title} | ProducerBuddy`
    : 'ProducerBuddy — All in One Film Solution';

  const finalDesc = description || DEFAULT_DESC;
  const finalUrl = url || BASE_URL;
  const finalImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* ── Basic ── */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="robots" content={robots} />
      <meta name="application-name" content={SITE_NAME} />
      <link rel="canonical" href={finalUrl} />

      {/* ── Open Graph ── */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:type" content="website" />

      {/* ── Twitter / X ── */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />
      <meta name="twitter:site" content="@ProducerBuddy" />
    </Helmet>
  );
};

export default SEO;